import React, { useState, useEffect } from 'react';
import { isStoryExclusive } from '../../../helpers/story-helpers';
import { FourStarIcon } from '../../atoms/material-icons';
import { isMobile } from 'react-device-detect';
import get from 'lodash/get';
import { useSelector } from 'react-redux';
import CardImage from '../../atoms/cardimage';
import { BQLink } from '../../atoms/bqlink';
import { contentClick } from '../../../helpers/datalayer-utils';
import NewsForYou from '../../../json/story-test-page/newsForYou.json';

import './more-like-this-widget.m.css';
import BeepsCardBanner from '../../collection-templates/beeps-card-widget/beeps-card-banner';

const MoreLikeThisWidget = (props) => {
  const test_page = props?.story?.test_page;
  const [allStories, setAllStories] = useState([]);
  const userData = useSelector((state) => get(state, ['userData']));
  const pageType = useSelector((state) => get(state, ['qt', 'pageType']));

  useEffect(() => {
    if (!test_page) {
      (async () => {
        const storyId = props.story.id;
        const response = await (
          await fetch(`/api/v1/stories/${storyId}/related-stories?limit=5`)
        ).json();
        setAllStories(response['related-stories']);
      })();
    } else {
      setAllStories(NewsForYou);
    }
  }, []);

  return (
    <div data-nosnippet>
      {allStories?.length > 0 && (
        <>
          {props.type === 'premium' ? (
            <div styleName="premium-wrapper">
              <div styleName="more-like-this-heading">
                <img src="/images/red-lines.svg" alt="red-lines" styleName="red-lines" />
                <h4 styleName="heading premium-heading">NEWS FOR YOU</h4>
                <img src="/images/red-lines.svg" alt="red-lines" styleName="red-lines" />
              </div>
              <div
                styleName="section"
                className={allStories.length === 0 ? 'loading-more-like-this' : ''}
              >
                {allStories?.slice(0, 4)?.map((story, index) => (
                  <div
                    styleName="story premium-story"
                    key={story?.id + index}
                    onClick={() => contentClick(userData, story, pageType)}
                  >
                    <BQLink href={`/${story.slug}`} styleName="item">
                      <div className="mobile-only">
                        <CardImage
                          story={story}
                          imageType="image16x9"
                          aspectRatio={[16, 9]}
                          isLazy={true}
                          isExclusive={isStoryExclusive(story)}
                        />
                      </div>
                      <h5 styleName="text">
                        {story.headline}
                        {isStoryExclusive(story) && !isMobile && (
                          <span className="exclusive-icon">
                            <FourStarIcon color="#CE9445" size="14px" />
                          </span>
                        )}
                      </h5>
                    </BQLink>
                  </div>
                ))}
              </div>
              <BeepsCardBanner />
            </div>
          ) : (
            <div>
              <div styleName="more-like-this-heading">
                <img src="/images/red-lines.svg" alt="red-lines" />
                <h4 styleName="heading">MORE LIKE THIS</h4>
                <img src="/images/red-lines.svg" alt="red-lines" />
              </div>
              <div
                styleName="section"
                className={allStories?.length === 0 ? 'loading-more-like-this' : ''}
              >
                {allStories?.map((story, index) => (
                  <div
                    styleName="story"
                    key={story?.id + index}
                    onClick={() => contentClick(userData, story, pageType)}
                  >
                    <BQLink href={`/${story.slug}`} styleName="item card-list">
                      <CardImage
                        story={story}
                        imageType="image16x9"
                        aspectRatio={[16, 9]}
                        isLazy={true}
                        isExclusive={isStoryExclusive(story)}
                      />
                      <h5 styleName="text">{story.headline}</h5>
                    </BQLink>
                  </div>
                ))}
              </div>
            </div>
          )}
        </>
      )}
    </div>
  );
};

export default MoreLikeThisWidget;
